<template>
	<v-layout row wrap fill-height class="alerts">
		<v-flex xs12 md3>
			<v-card>
				<v-list
					class="py-0 admin__sidebar-menu"
					v-if="$vuetify.breakpoint.mdAndUp"
				>
					<v-list-tile @click="toggleAll" ripple>
						<v-list-tile-action>
							<v-icon
								:color="form.to.length > 0 ? 'accent' : ''"
								>{{ icon }}</v-icon
							>
						</v-list-tile-action>

						<v-list-tile-content>
							<v-list-tile-title
								v-text="
									form.to.length === recipients.length
										? 'Unselect All'
										: 'Select All'
								"
							></v-list-tile-title>
						</v-list-tile-content>
					</v-list-tile>

					<v-list-tile
						v-for="recipient in recipients"
						:key="recipient.id"
						@click="toggle(recipient.id)"
						ripple
					>
						<v-list-tile-action>
							<v-icon
								:color="form.to.length > 0 ? 'accent' : ''"
								v-text="
									findRecipient(recipient.id)
										? 'check_box'
										: 'check_box_outline_blank'
								"
							></v-icon>
						</v-list-tile-action>

						<v-list-tile-content>
							<span v-html="recipientName(recipient)"></span>
						</v-list-tile-content>
					</v-list-tile>
				</v-list>

				<v-list v-else class="py-0">
					<v-list-group
						:value="listOpen"
						@click="listOpen = !listOpen"
					>
						<v-list-tile
							slot="activator"
							class="decision-tree__category"
						>
							<v-list-tile-content>
								<v-list-tile-title
									>All Recipients</v-list-tile-title
								>
							</v-list-tile-content>
						</v-list-tile>

						<v-list-tile @click="toggleAll" ripple>
							<v-list-tile-action>
								<v-icon
									:color="form.to.length > 0 ? 'accent' : ''"
									>{{ icon }}</v-icon
								>
							</v-list-tile-action>

							<v-list-tile-content>
								<v-list-tile-title
									v-text="
										form.to.length === recipients.length
											? 'Unselect All'
											: 'Select All'
									"
								></v-list-tile-title>
							</v-list-tile-content>
						</v-list-tile>

						<v-list-tile
							v-for="recipient in recipients"
							:key="recipient.id"
							@click="toggle(recipient.id)"
							ripple
						>
							<v-list-tile-action>
								<v-icon
									:color="form.to.length > 0 ? 'accent' : ''"
									v-text="
										findRecipient(recipient.id)
											? 'check_box'
											: 'check_box_outline_blank'
									"
								></v-icon>
							</v-list-tile-action>

							<v-list-tile-content>
								<span v-html="recipientName(recipient)"></span>
							</v-list-tile-content>
						</v-list-tile>
					</v-list-group>
				</v-list>
			</v-card>
		</v-flex>

		<v-flex xs12 md9>
			<v-card>
				<v-form ref="form">
					<v-card-text class="pb-1">
						<v-text-field
							name="subject"
							v-model="form.subject"
							hide-details
							placeholder="Subject"
						></v-text-field>
					</v-card-text>
					<v-card-text class="py-0 px-1">
						<v-textarea
							name="body"
							v-model="form.body"
							flat
							solo
							:rows="3"
							hide-details
							background-color="white"
							placeholder="Send a Message..."
							auto-grow
							@keydown.meta.enter="send"
						></v-textarea>
					</v-card-text>

					<v-card-actions>
						<v-spacer></v-spacer>
						<v-tooltip top>
							<template v-slot:activator="{ on }">
								<v-btn
									icon
									@click="send"
									v-on="on"
									:loading="loading"
									:disabled="loading"
								>
									<div class="v-icon">
										<fa-icon
											:icon="['far', 'paper-plane']"
											size="xs"
										/>
									</div>
								</v-btn>
							</template>
							<span>Send</span>
						</v-tooltip>
					</v-card-actions>
				</v-form>
			</v-card>
		</v-flex>
	</v-layout>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Errors from "@root/helpers/Errors";
import { longStackSupport } from "q";

export default {
	data() {
		return {
			notifications: false,
			form: {
				to: [],
				subject: "",
				body: ""
			},
			loading: false,
			errors: new Errors()
		};
	},

	computed: {
		...mapGetters(["dark", "user", "currentTeam", "searchQuery"]),

		...mapGetters("messages", {
			RECIPIENTS: "recipients"
		}),

		searchRegex() {
			return (flags = "gi") => new RegExp(this.searchQuery, flags);
		},

		allSelected() {
			return this.form.to.length === this.recipients.length;
		},

		someSelected() {
			return this.form.to.length > 0 && !this.allSelected;
		},

		icon() {
			if (this.allSelected) {
				return "check_box";
			}

			if (this.someSelected) {
				return "indeterminate_check_box";
			}

			return "check_box_outline_blank";
		},

		recipients() {
			if (this.RECIPIENTS) {
				return this.RECIPIENTS.filter(recipient => {
					if (!this.searchQuery) {
						return true;
					}

					// console.log(this.searchQuery);

					let term1 = recipient.name.toLowerCase(),
						term2 = recipient.email.toLowerCase(),
						sq = this.searchQuery.toLowerCase();

					return term1.indexOf(sq) !== -1 || term2.indexOf(sq) !== -1;
				});
			}

			return [];
		}
	},

	methods: {
		...mapActions("messages", {
			GET_RECIPIENTS: "getRecipients",
			POST_ALERT: "postAlert"
		}),

		toggleAll() {
			this.$nextTick(() => {
				if (this.allSelected) {
					this.form.to = [];
				} else {
					this.form.to = _.map(this.recipients, "id").slice();
				}
			});
		},

		toggle(recipient) {
			let index = _.findIndex(this.form.to, r => r === recipient);

			if (index === -1) {
				this.form.to.push(recipient);
			} else {
				this.form.to.splice(index, 1);
			}
		},

		findRecipient(recipient_id) {
			return this.form.to.find(id => {
				return id === recipient_id;
			});
		},

		send() {
			this.loading = true;

			let formData = new FormData();

			_.forEach(this.form, (value, key) => {
				formData.append(key, value);
			});

			this.POST_ALERT(formData)
				.then(data => {
					this.loading = false;

					this.$refs.form.reset();
					this.form = {
						to: [],
						subject: "",
						body: ""
					};
				})
				.catch(error => {
					this.loading = false;

					error = Object.assign({}, error);
					this.errors.record(error.response.data.errors);

					let errorText = "Please ";

					if (this.errors.has("to")) {
						errorText += "select a recipient";
					}

					if (this.errors.has("body")) {
						if (this.errors.has("to")) {
							errorText += " and ";
						}

						errorText += "enter a message";
					}

					this.$swal({
						text: errorText + ".",
						type: "error",
						confirmButtonText: "Okay"
					});
				});
		},

		reset() {
			this.$refs.form.reset();
		},

		getRecipients(val) {
			if (this.recipients.length === 0) {
				this.GET_RECIPIENTS();
			}
		},

		recipientName(recipient) {
			let recipient_name = recipient.name;

			if (this.searchQuery) {
				return this.highlight(recipient_name);
			}

			return recipient_name;
		},

		highlight(text, flags) {
			return (text = text.replace(this.searchRegex(flags), found => {
				return `<span class="search-highlight">${found}</span>`;
			}));
		}
	},

	created() {
		this.getRecipients();
	}
};
</script>
